import styled from 'styled-components';
import { Content as ThemeContent } from '../../../../theme/layout';
import { paragraph } from '../../../../theme/typography';
import { SnackbarContainer } from '../snackbarRender.styles';

export const Container = styled(SnackbarContainer)``;

export const Content = styled(ThemeContent)`
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const Text = styled.p`
  ${paragraph};
  margin-left: 20px;
  color: white;
`;
